// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"7064":"e0daf192","8804":"141ff337"}[chunkId] + ".css";
};